import React from 'react';
import { useTranslation } from 'react-i18next';
export var CareRecSlideoverTitle = function () {
    var t = useTranslation().t;
    return (React.createElement("div", { className: "border-x-0 border-b border-t-0 border-solid border-gray-200 bg-gray-50 p-4 md:p-6" },
        React.createElement("h2", { className: "text-lg font-medium leading-7 tracking-tight text-black md:text-xl" }, t('careRecSlideover.title.header', 'Care Recommendations')),
        React.createElement("p", { className: "text-base font-normal tracking-tight text-gray-500" }, t('careRecSlideover.title.subheader', 'Possible results based on symptom severity and urgency'))));
};
export default CareRecSlideoverTitle;
